(ns io.daskul.webapp.widgets.form.section-rows
  "Pure row-layout logic for F-056 form sections (:ui :form :sections).

   In a section's :fields, a bare keyword is a full-width row and a nested
   vector is one explicit multi-column row — no auto-flow, no spans; field
   adjacency is always intentional. Kept free of UI imports so it runs under
   :node-test.")

(defn field-rows
  "Normalize a section's :fields into a vector of rows (vectors of keywords).
   Bare keyword → single-field row; nested vector → one row as declared."
  [section]
  (mapv #(if (vector? %) % [%]) (:fields section)))

(defn resolve-rows
  "Resolve a section's rows against schema fields. Returns a vector of rows
   of field maps, in declaration order, skipping fields not in the schema
   and dropping rows left empty."
  [section schema-fields]
  (let [fields-by-name (into {} (map (juxt :name identity)) schema-fields)]
    (into []
          (comp (map (fn [row] (into [] (keep fields-by-name) row)))
                (remove empty?))
          (field-rows section))))

(defn create-sections
  "Adapt sections for a create form (F-056 create adoption). Drops widget
   sections (:activity/:notes are detail-only), strips detail-only options
   (:placement, :visible-states, :readonly — a create form has no sidebar,
   no record state), and drops sections none of whose fields exist in the
   create schema. Empty result ⇒ caller falls back to the flat form."
  [sections schema-fields]
  (into []
        (comp (remove :widget)
              (map #(dissoc % :placement :visible-states :readonly))
              (filter #(seq (resolve-rows % schema-fields))))
        sections))

(defn split-sections
  "Split sections into {:main [...] :sidebar [...]}.
   Sections without :placement default to :main."
  [sections]
  (let [grouped (group-by #(or (:placement %) :main) sections)]
    {:main (vec (get grouped :main))
     :sidebar (vec (get grouped :sidebar))}))

(defn unsectioned-fields
  "Return schema fields not assigned to any section (row vectors flattened)."
  [sections schema-fields]
  (let [sectioned (into #{} (mapcat #(reduce into [] (field-rows %))) sections)]
    (filterv #(not (sectioned (:name %))) schema-fields)))
